/**
 * API 函数统一导出
 */
export { login } from './login';
export { signUp } from './signup';
export { chat } from './chat';
export { redeem } from './redeem';
export { updateDcoin } from './updateDcoin';
export { updateUserInfo } from './updateUserInfo';
export { getUserInfo } from './getUserInfo';
export { getRechargeHistory } from './getRechargeHistory';
export type { RechargeRecord, RechargeHistoryResponse } from './getRechargeHistory';
export { sendVerificationCode } from './emailVerification';

/**
 * 蓝牙功能导出
 */

